export default __webpack_public_path__ + "static/media/human-endocrine.9cfec007.svg";